import { updateSlideInDeck } from "../editor/deckEditor.js";
import { estimateSeconds } from "./scriptEstimate.js";
import { slideTextHash } from "./scriptHash.js";
export const DEFAULT_SPEAKER_SCRIPT_CONFIG = {
    wordsPerMinute: 140,
    defaultTone: "narrative",
};
export function resolveSpeakerScriptConfig(deck) {
    return { ...DEFAULT_SPEAKER_SCRIPT_CONFIG, ...deck.speakerScriptConfig };
}
export function emptySpeakerScript() {
    return { text: "", status: "empty" };
}
export function setSpeakerScript(deck, slideId, patch) {
    const wpm = resolveSpeakerScriptConfig(deck).wordsPerMinute;
    return updateSlideInDeck(deck, slideId, (slide) => {
        const prev = slide.speakerScript ?? emptySpeakerScript();
        const text = patch.text !== undefined ? patch.text : prev.text;
        const status = patch.status ??
            (patch.text !== undefined && patch.text !== prev.text ? "edited" : prev.status);
        const next = {
            ...prev,
            ...patch,
            text,
            status: text.trim() ? status : "empty",
            estimatedSeconds: estimateSeconds(text, wpm),
            updatedAt: new Date().toISOString(),
        };
        return { ...slide, speakerScript: next };
    });
}
export function clearSpeakerScript(deck, slideId) {
    return updateSlideInDeck(deck, slideId, (slide) => {
        const { speakerScript: _removed, ...rest } = slide;
        return rest;
    });
}
export function markScriptStaleIfChanged(deck, slideId) {
    return updateSlideInDeck(deck, slideId, (slide) => {
        const script = slide.speakerScript;
        if (!script?.generatedFromHash || !script.text.trim())
            return slide;
        const currentHash = slideTextHash(slide, deck);
        if (currentHash === script.generatedFromHash)
            return slide;
        if (script.status === "stale")
            return slide;
        return {
            ...slide,
            speakerScript: { ...script, status: "stale" },
        };
    });
}
export function markAllScriptsStaleIfChanged(deck) {
    let next = deck;
    for (const slide of deck.slides) {
        next = markScriptStaleIfChanged(next, slide.id);
    }
    return next;
}
export function setSpeakerScriptConfig(deck, patch) {
    const config = { ...resolveSpeakerScriptConfig(deck), ...patch };
    return { ...deck, speakerScriptConfig: config };
}
